import React from "react";
import { ContentView } from "../../components/content-view/ContentView";
import ContextualAppBar from "../../components/contextual-app-bar/ContextualAppBar";
import { ViewOptionStateEnum } from "../../components/contextual-app-bar/ViewOptionStateEnum";
import SearchViewContent from "./SearchViewContent";

export default function SearchView() {
    return (
        <ContentView>
            <ContextualAppBar viewOptionState={ViewOptionStateEnum.Hidden}/>            
            <SearchViewContent />
        </ContentView>        
    );
}
